import React, { FC, useEffect, useState } from "react";
import DataTable from 'react-data-table-component';
import { API_URL } from "../../../../actions/settings";
import { IonButton, IonIcon } from "@ionic/react";
import  { default as regressionIcon }  from "../../../../AE2/static/icons/regression.svg";
import { createOutline } from "ionicons/icons";
import EditAdjustmentMethodModal from "./EditAdjustmentMethodModal";
import useToggle from "../../../../utils/useToggle";

interface IProps {
    id:string|null,
    setRegressionMeter:any
};

async function getMeters(token: string, id: string|null) {
  return fetch(`${API_URL}/buildings/${id}/meters`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: token,
    },
  }).then((res) =>
    res.json());
}

const AdjustmentsMetersTable:FC<IProps> = ({id,setRegressionMeter}) => {
    const [data,setData] = useState([])
    const [error,setError] = useState(null)
    const [selectedMeter,setSelectedMeter] = useState('')
    const [openMethodModal, setMethodModal] = useState(false)
    const [reload,toggleReload] = useToggle()


    useEffect(() => {
    const handleData = async () => {
      const token = `Token ${(localStorage.getItem("token") || "").slice(1,-1)}`;
      const res = await getMeters(token, id);
      if(res.error){
        setError(res.error)
      }
      else setData(res.data)
    //   setLoading(false);
    };

    handleData();
  }, [id,reload]);

  const columns = [
        {
            name: 'Name',
            selector: (row:any) => {

                return <div>
                    <a href={`/energystar/meters/${row.id}`}><span style={{fontWeight:'bold', color:'white',textDecoration:'underline',textDecorationColor:'white'}}>{row.name}</span></a>
                    <div style={{fontSize:'smaller'}}>{row.meter_id}</div>
                </div> 
            },
            sortable: true,
        },
        {
            name: 'Meter Type',
            selector: (row:any) => {

                return row.type.name
            },
            sortable: true,
        },
        {
            name: 'Baseline Adjustment Method',
            selector: (row:any) => row.baseline_adjustment_method.name,
            sortable: false,
        },
        {
            name: 'Edit Method',
            selector: (row:any) => <IonButton slot="icon-only" color={"light"} title="Edit Cost Avoidance Method" onClick={()=>{setSelectedMeter(row.id);setMethodModal(true)}}>
              <IonIcon src={createOutline} />
            </IonButton>,
            sortable: false,
        },
        {
            name: 'Regressions',
            selector: (row:any) => <div><IonButton slot="icon-only" color={"light"} title="Run Regression Analysis" onClick={()=>setRegressionMeter([row.id,row.name])}
            ><IonIcon src={regressionIcon}/></IonButton> </div>,
            sortable: false,
        },
    ];

    if(error){
        return <div>
            {error}
        </div>
    }
    
    return <div>
      <DataTable
          title="Meters"
          columns={columns}
          data={data}
          pagination
          theme='dark'

        />
        <EditAdjustmentMethodModal meter={selectedMeter} openModal={openMethodModal} setOpenModal={setMethodModal} reload={toggleReload}/>
    </div>
     
};

export default AdjustmentsMetersTable;